module.exports = __webpack_public_path__ + "static/oblex_spawn-d239a2cd7dba9ef97802bd6cd8e100dd.png";